import React, { Fragment, useEffect } from "react";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import AtomFeatures from "../../components/AtomFeatures";

const AtomFeaturesPage: React.FC = () => {
  useEffect(() => {
    document.title = "Atom Features | Atom Foundation L3 Powered by Ethereum";
  }, []);

  return (
    <Fragment>
      <div className="lab-page inner-page">
        <div className="body_wrap o-clip">
          <main>
            <AtomFeatures />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default AtomFeaturesPage;
